
export * from '../../frontend-js-state-web/__liferay__/index.js';
